angular.module('qkr').config(['$httpProvider', function($httpProvider) {
    // Initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
}]);

angular.module('qkr').config(['$uibTooltipProvider', function($uibTooltipProvider) {
    $uibTooltipProvider.options({
        appendToBody: true
    });
}]);

angular.module('qkr').run((gettextCatalog, messageService, appConfig, utils) => {
    gettextCatalog.currentLanguage = utils.getLocale(appConfig.locale, appConfig.poFileNames);

    messageService.log('Current Language*=' + gettextCatalog.currentLanguage);

    // Debug mode to test
    if (appConfig.env !== 'production') {
        gettextCatalog.debug = true;
    }
});

angular.module('qkr').config(($routeSegmentProvider, appUrl) => {
    $routeSegmentProvider.when('/requestReset', 'requestReset', { pageTitle: 'Password Reset'});

    $routeSegmentProvider.
        segment('requestReset', {
        controller: 'PasswordRequestResetController',
        template: require('./templates/password/reset.request.html')
    });
});



// WEBPACK FOOTER //
// ./src/password.requestreset.js